// src/pages/NotFoundPage.js
import React from 'react';
import { Link, useNavigate } from 'react-router-dom';
import Mascot from '../components/Mascot';
import '../styles/components/StatePage.css';

export default function NotFoundPage() {
  const navigate = useNavigate();

  return (
    <div className="state-page">
      <div className="state-page__inner">
        <div>
          <p className="state-page__display">Wrong turn.</p>
          <p className="state-page__code">ERROR 404 · PAGE NOT FOUND</p>
        </div>
        <div className="state-page__side">
          <div className="state-say">
            <Mascot size={40} />
            <div className="state-say__bubble">
              <b>Michii says</b>
              <span>I looked everywhere. This page isn’t here.</span>
            </div>
          </div>
          <h1 className="state-page__title">Page not found</h1>
          <p className="state-page__desc">The page you’re looking for doesn’t exist or has been moved.</p>
          <div className="state-page__actions">
            <button className="lp-btn" onClick={() => navigate('/')}>Go home</button>
            <Link to="/explore" className="lp-tlink">Explore guides</Link>
          </div>
        </div>
      </div>
    </div>
  );
}
